export default "__VITE_ASSET__CaGCWEZ2__"